module.exports = require("/Users/remotemonkey/DEVELOP/NADER-ABOU-ANAS/front-end-dourous/src/redux/store")